import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverPayRateGroupList extends Layout {
    layoutheaderDriverPayRateGroup: LayoutHeader;
    sourceDrsPayrateGroupList: DataSource;
    tableDriverPayRateGroup: Table;
}
